export default __webpack_public_path__ + "static/media/nine.607b60f3.png";